module.exports = __webpack_public_path__ + "static/media/77developers.195de3c2.png";